/* eslint import/no-cycle: [2, { maxDepth: 1 }] */
import { AssetAttributes } from './asset-attributes';
import { AssetRelationships } from './asset-relationships';

export interface Asset {
  type: 'assets'
  id: string | null
  attributes: AssetAttributes
  relationships?: AssetRelationships
}

export const reisTypeOfUse = [
  {
    sector_id: "Lnd",
    sector_name: "Land"
  },
  {
    sector_id: "Gen",
    sector_name: "Other"
  },
  {
    sector_id: "All",
    sector_name: "Multi-Sector"
  },
  {
    sector_id: "Ind",
    sector_name: "Logistics"
  },
  {
    sector_id: "Hot",
    sector_name: "Hotel"
  },
  {
    sector_id: "Spc",
    sector_name: "Specialty"
  },
  {
    sector_id: "Ret",
    sector_name: "Retail"
  },
  {
    sector_id: "Off",
    sector_name: "Office"
  },
  {
    sector_id: "Apt",
    sector_name: "Multifamily"
  },
  {
    sector_id: "Flx",
    sector_name: "Flex/R&D"
  },
  {
    sector_id: "Dis",
    sector_name: "Warehouse/Distribution"
  },
  {
    sector_id: "Aff",
    sector_name: "Affordable_Housing"
  },
  {
    sector_id: "Sto",
    sector_name: "Self_Storage"
  },
  {
    sector_id: "Snr",
    sector_name: "Senior_Housing"
  },
  {
    sector_id: "Sth",
    sector_name: "Student_Housing"
  }
]

export const noNullableAttributes = ['country_code', 'asset_status'];
